import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = {
  id: "Nav",
  class: "left"
}
const _hoisted_3 = { class: "back" }
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "maintitle s60" }
const _hoisted_7 = { class: "desc" }
const _hoisted_8 = {
  id: "Main",
  class: "right"
}
const _hoisted_9 = {
  class: "logo",
  "data-color": "cyan50"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = ["alt"]
const _hoisted_12 = { class: "intro" }
const _hoisted_13 = { class: "maintitle s36" }
const _hoisted_14 = {
  key: 0,
  ref: "form",
  class: "form"
}
const _hoisted_15 = { class: "item" }
const _hoisted_16 = { for: "Email" }
const _hoisted_17 = ["placeholder"]
const _hoisted_18 = { class: "item" }
const _hoisted_19 = { for: "Password" }
const _hoisted_20 = {
  class: "custominput",
  "data-type": "password"
}
const _hoisted_21 = {
  key: 0,
  class: "item"
}
const _hoisted_22 = { for: "PasswordCheck" }
const _hoisted_23 = {
  class: "custominput",
  "data-type": "password"
}
const _hoisted_24 = {
  key: 0,
  class: "validation-summary-errors"
}
const _hoisted_25 = { class: "item" }
const _hoisted_26 = { class: "cta" }

import { ref, onBeforeMount } from "vue";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountPasswordReset',
  props: {
    code: {}
  },
  setup(__props: any) {

const props = __props;

const localizer = Localizer;
const formHelper = FormHelper;
const routes = (window as any).App.routes;

const isLoading = ref(false);
const isSuccess = ref(false);
const options = ref<any>(null);
const formData = ref<any>({});
const validationErrors = ref<any[]>([]);
const isHidden = ref(true);
const isHiddenCheck = ref(true);

onBeforeMount(async () => {
    options.value = (await Axios.post(routes.Account_User_GetOptions, null, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;
    formData.value.code = props.code;
});

function back() {
    window.history.back();
}

async function submitForm() {
    FormHelper.removeFocus();

    validationErrors.value = [];
    isLoading.value = true;

    try {
        let result = (await Axios.post(routes.Account_User_PasswordReset, formData.value, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;
        isSuccess.value = true;
        window.location.href = result.redirectUrl;
    } catch (error: any) {
        formData.value.password = null;
        formData.value.passwordCheck = null;
        if (error.response && error.response.status === 400) {
            validationErrors.value = FormHelper.getValidationErrors(error.response.data);
        }
    }

    isLoading.value = false;
}

function showPasswordIcon() {
    isHidden.value = !isHidden.value;
}

function showPasswordCheckIcon() {
    isHiddenCheck.value = !isHiddenCheck.value;
}

return (_ctx: any,_cache: any) => {
  const _component_app_footer = _resolveComponent("app-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (back())),
          class: "button icon fastic-circle-left",
          "aria-label": _unref(localizer).get('App.Common.PageBack')
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h1", _hoisted_6, _toDisplayString(_unref(localizer).get("Account.PasswordReset.Title")), 1),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(localizer).get("Account.PasswordReset.Desc")), 1)
      ]),
      _createVNode(_component_app_footer)
    ]),
    _createElementVNode("main", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("a", {
          href: _unref(routes).Home
        }, [
          _createElementVNode("img", {
            src: "/images/logo.svg",
            width: "125",
            height: "35",
            alt: _unref(localizer).get('App.Common.Beghelli')
          }, null, 8, _hoisted_11)
        ], 8, _hoisted_10)
      ]),
      _createElementVNode("div", {
        onKeydown: _cache[7] || (_cache[7] = _withKeys(_withModifiers(($event: any) => (submitForm()), ["prevent","stop"]), ["enter"])),
        class: "content"
      }, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("h2", _hoisted_13, _toDisplayString(_unref(localizer).get("Account.PasswordReset.NewPassword")), 1)
        ]),
        (options.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _createElementVNode("fieldset", null, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("label", _hoisted_16, _toDisplayString(_unref(localizer).get("App.Form.Email")), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    id: "Email",
                    placeholder: _unref(localizer).get('App.Form.EmailPlaceholder'),
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.email) = $event)),
                    class: _normalizeClass([{ 'input-validation-error': _unref(formHelper).isControlValidationError('Email', validationErrors.value) }, 'input w300'])
                  }, null, 10, _hoisted_17), [
                    [
                      _vModelText,
                      formData.value.email,
                      void 0,
                      { lazy: true }
                    ]
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("label", _hoisted_19, _toDisplayString(_unref(localizer).get("Account.Common.Password")), 1),
                  _createElementVNode("div", _hoisted_20, [
                    _withDirectives(_createElementVNode("input", {
                      type: "password",
                      "aria-label": "Password",
                      id: "Password",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.password) = $event)),
                      class: _normalizeClass([{ 'input-validation-error': _unref(formHelper).isControlValidationError('Password', validationErrors.value) }, 'input w300'])
                    }, null, 2), [
                      [
                        _vModelText,
                        formData.value.password,
                        void 0,
                        { lazy: true }
                      ]
                    ]),
                    _createElementVNode("button", {
                      class: _normalizeClass([{ 'fastic-eye-show': isHidden.value, 'fastic-eye-hide': !isHidden.value }, 'showhide']),
                      "aria-label": "Mostra password",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(formHelper).showPassword('Password'), showPasswordIcon()))
                    }, null, 2)
                  ])
                ]),
                (options.value.isPasswordCheck)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createElementVNode("label", _hoisted_22, _toDisplayString(_unref(localizer).get("Account.Common.PasswordCheck")), 1),
                      _createElementVNode("div", _hoisted_23, [
                        _withDirectives(_createElementVNode("input", {
                          type: "password",
                          "aria-label": "Verifica password",
                          id: "PasswordCheck",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.passwordCheck) = $event)),
                          class: _normalizeClass([{ 'input-validation-error': _unref(formHelper).isControlValidationError('PasswordCheck', validationErrors.value) }, 'input w300'])
                        }, null, 2), [
                          [
                            _vModelText,
                            formData.value.passwordCheck,
                            void 0,
                            { lazy: true }
                          ]
                        ]),
                        _createElementVNode("button", {
                          class: _normalizeClass([{ 'fastic-eye-show': isHiddenCheck.value, 'fastic-eye-hide': !isHiddenCheck.value }, 'showhide']),
                          "aria-label": "Mostra password",
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(formHelper).showPassword('PasswordCheck'), showPasswordCheckIcon()))
                        }, null, 2)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("fieldset", null, [
                (validationErrors.value.length !== 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validationErrors.value, (validationError, index) => {
                          return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(validationError.message), 1))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("button", {
                      class: _normalizeClass([{ 'loading': isLoading.value }, 'button']),
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (submitForm()))
                    }, [
                      (!isLoading.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_unref(localizer).get("Account.Common.Button_Next")), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ], 2)
                  ])
                ])
              ])
            ], 512))
          : _createCommentVNode("", true)
      ], 32)
    ])
  ]))
}
}

})